import React from 'react'
import { CSSTransition } from 'react-transition-group'

import iconFacebookCircle from 'images/icons/facebook-circle.svg'
import iconInstagramCircle from 'images/icons/instagram-circle.svg'
import iconLinkedinCircle from 'images/icons/linkedin-circle.svg'
import iconTwitterCircle from 'images/icons/twitter-circle.svg'
import bgLoading from 'images/loading.gif'

class Loader extends React.Component {
  constructor(props) {
    super(props);

    this.state = { current: 1 }
  }

  componentDidMount() {
    this.changeText()
  }

  changeText = () => {
    setInterval(() => {
      if (this.state.current === 3) this.setState({ current: 0 })

      this.setState({ current: this.state.current + 1 })
    }, 6000)
  }

  render() {
    const { current } = this.state

    return (
      <React.Fragment>
        <div className="absolute bg-white bottom-0 left-0 md-center px4 right-0 top-0 z6">
          <React.Fragment>
            <div className="absolute col-12 h2 left-50p md-px3 medium sm-h3 top-50p transform-center" style={{ maxWidth: '800px' }}>
              <div className="center mb4">
                <img alt="Loading" src={bgLoading} />
              </div>

              <div className="mt4 py3 relative">
                <CSSTransition
                  in={current === 1}
                  classNames="fade--1500 fade"
                  timeout={1500}
                  unmountOnExit
                >
                  <p className="absolute center col-12 left-0 sm-px3 top-0">Have a sip of coffee! I'm fetching the data...</p>
                </CSSTransition>

                <CSSTransition
                  in={current === 2}
                  classNames="fade--1500 fade"
                  timeout={1500}
                  unmountOnExit
                >
                  <p className="absolute center col-12 left-0 sm-px3 top-0">Got it! Just need to make it look good...</p>
                </CSSTransition>

                <CSSTransition
                  in={current === 3}
                  classNames="fade--1500 fade"
                  timeout={1500}
                  unmountOnExit
                >
                  <p className="absolute center col-12 left-0 sm-px3 top-0">Almost done! You're going to love this...</p>
                </CSSTransition>
              </div>

              <div className="load-bar sm-mt3">
                <div className="bar" />
                <div className="bar" />
                <div className="bar" />
              </div>
            </div>

            <p className="absolute flex flex-center flex-justify-center left-50p transform-horizontal-center" style={{ bottom: '10%' }}>
              <img alt="" className="block mr-10 sm-mb2" src={iconInstagramCircle} />

              <img alt="" className="block mr-10 sm-mb2" src={iconFacebookCircle} />

              <img alt="" className="block mr-10 sm-mb2" src={iconTwitterCircle} />

              <img alt="" className="block mr-10 sm-mb2" src={iconLinkedinCircle} />
            </p>
          </React.Fragment>
        </div>
      </React.Fragment>
    )
  }
}

export default Loader
